(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 719px)';
  var RESIZE_DEBOUNCE_MS = 150;

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function readIncrement(grid) {
    var mobile = isMobile();
    return parseInt(grid.dataset[mobile ? 'incrementMobile' : 'incrementDesktop'], 10) || 0;
  }

  function getItems(grid) {
    return Array.prototype.slice.call(grid.querySelectorAll('.multi-column__grid-item'));
  }

  function revealNext(grid, count) {
    var mobile = isMobile();
    var hiddenClass = mobile ? 'is-lm-hidden-mobile' : 'is-lm-hidden-desktop';
    var hidden = getItems(grid).filter(function (el) {
      return el.classList.contains(hiddenClass);
    });
    hidden.slice(0, count).forEach(function (el) {
      el.classList.remove(hiddenClass);
    });
  }

  function syncButton(section) {
    var grid = section.querySelector('[data-load-more-grid]');
    var btn = section.querySelector('[data-load-more-trigger]');
    if (!grid || !btn) return;
    var hiddenClass = isMobile() ? 'is-lm-hidden-mobile' : 'is-lm-hidden-desktop';
    var anyStillHidden = getItems(grid).some(function (el) {
      return el.classList.contains(hiddenClass);
    });
    if (!anyStillHidden) {
      btn.setAttribute('hidden', '');
    } else {
      btn.removeAttribute('hidden');
    }
  }

  function init(section) {
    var grid = section.querySelector('[data-load-more-grid]');
    var btn = section.querySelector('[data-load-more-trigger]');
    if (!grid || !btn) return;
    if (btn.dataset.lmBound === 'true') return;
    btn.dataset.lmBound = 'true';
    btn.addEventListener('click', function () {
      revealNext(grid, readIncrement(grid));
      syncButton(section);
    });
    syncButton(section);
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.querySelectorAll('[data-section-type="multi-column"]');
    Array.prototype.forEach.call(sections, init);
  }

  if (!window._mcLmResizeBound) {
    window._mcLmResizeBound = true;
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var sections = document.querySelectorAll('[data-section-type="multi-column"]');
        Array.prototype.forEach.call(sections, syncButton);
      }, RESIZE_DEBOUNCE_MS);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target;
    if (!target) return;
    if (target.matches('[data-section-type="multi-column"]')) {
      init(target);
    } else {
      initAll(target);
    }
  });
})();
